import React, { useEffect } from "react";
import { Table, Typography } from "antd";
import { withRouter } from "react-router-dom";
import moment from "moment";

const FollowUpTable = (props) => {
  const { pagination, dataSource, spinner, history, activeFollowUpTab } = props;

  useEffect(() => {
    return () => {
      // Clear filters/pagination only if we are navigating out of the Follow-Ups section
      if (!window.location.pathname.startsWith("/autoadmin/follow-ups")) {
        localStorage.removeItem("activeFollowUpTab");
        localStorage.removeItem("activeFollowUpTab_timestamp");
      }
    };
  }, []);

  const column = [
    {
      title: "Quotation Id",
      dataIndex: "quotationId",
      key: "quotationId",
      render: (record) => <span>{record}</span>,
    },
    {
      title: "Customer Name",
      dataIndex: "name",
      key: "name",
      render: (record) => {
        return <span>{record}</span>;
      },
    },
    {
      title: "Mobile No",
      dataIndex: "phone",
      key: "phone",
      render: (record) => {
        return <span>{record}</span>;
      },
    },
    {
      title: "Created On",
      dataIndex: "createdAt",
      key: "createdAt",
      render: (record) => (
        <span>{moment(new Date(record)).format("DD/MM/YYYY")}</span>
      ),
    },
    {
      title: "Next Followup Date",
      dataIndex: "scheduleDateAndTime",
      key: "scheduleDateAndTime",
      render: (record, row) => {
        // scheduleDateAndTime is the reliable field; fall back to scheduleDate.
        // Guard against null: new Date(null) returns epoch 01/01/1970.
        const dateVal = record || row.scheduleDate;
        if (!dateVal) return <span>-</span>;
        const parsed = moment(dateVal);
        return <span>{parsed.isValid() ? parsed.format("DD/MM/YYYY") : "-"}</span>;
      },
    },
  ];

  return (
    <Table
      onRow={(record, index) => {
        return {
          onClick: () => {
            localStorage.setItem(
              "activeFollowUpTab",
              JSON.stringify(activeFollowUpTab)
            );
            localStorage.setItem("activeFollowUpTab_timestamp", Date.now().toString());
            
            history.push(
              `/autoadmin/follow-ups/${record.phone}/fupdate/${record.scheduleDateAndTime || record.scheduleDate || record.createdAt}`
            );
          },
        };
      }}
      style={{ cursor: "pointer" }}
      pagination={pagination}
      columns={column}
      dataSource={dataSource}
      loading={spinner}
    />
  );
}

export default withRouter(FollowUpTable)